import { Link, NavLink, useNavigate } from 'react-router-dom';
import { Bell, Package, Plane, LogOut, PlusCircle } from 'lucide-react';
import { useAuthStore } from '../../store/authStore';
import { authService } from '../../services';
import toast from 'react-hot-toast';

export default function Navbar() {
  const { user, isAuthenticated, logout } = useAuthStore();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try { await authService.logout(); } catch { /* ignorer */ }
    logout();
    navigate('/login');
    toast.success('Déconnecté avec succès');
  };

  const navLinkClass = ({ isActive }: { isActive: boolean }) =>
    `flex items-center gap-1.5 text-sm font-medium px-3 py-1.5 rounded-lg transition-colors ${
      isActive
        ? 'text-brand-600 bg-brand-50'
        : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
    }`;

  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 font-bold text-xl text-brand-600 no-underline">
            <span>✈️</span>
            <span>ColisEco</span>
          </Link>

          {/* Navigation */}
          <nav className="hidden md:flex items-center gap-1">
            <NavLink to="/trips" className={navLinkClass}>
              <Plane size={16} /> Trajets
            </NavLink>
            {isAuthenticated && (
              <>
                <NavLink to="/bookings" className={navLinkClass}>
                  <Package size={16} /> Mes envois
                </NavLink>
                <NavLink to="/trips/new" className={navLinkClass}>
                  <PlusCircle size={16} /> Proposer un trajet
                </NavLink>
              </>
            )}
          </nav>

          {/* Actions */}
          <div className="flex items-center gap-2">
            {isAuthenticated ? (
              <>
                <Link to="/notifications" className="btn-ghost btn-sm relative">
                  <Bell size={18} />
                </Link>
                <Link to="/profile" className="btn-ghost btn-sm flex items-center gap-2">
                  {user?.avatarUrl
                    ? <img src={user.avatarUrl} alt="" className="w-7 h-7 rounded-full object-cover" />
                    : <div className="w-7 h-7 rounded-full bg-brand-100 flex items-center justify-center text-brand-600 text-xs font-semibold">
                        {user?.firstName?.[0]}{user?.lastName?.[0]}
                      </div>
                  }
                  <span className="hidden sm:inline text-sm">{user?.firstName}</span>
                </Link>
                <button onClick={handleLogout} className="btn-ghost btn-sm text-gray-500">
                  <LogOut size={16} />
                </button>
              </>
            ) : (
              <>
                <Link to="/login"    className="btn-secondary btn-sm">Connexion</Link>
                <Link to="/register" className="btn-primary btn-sm">S'inscrire</Link>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
